<template>
  <v-stepper v-model="step" elevation="0">    
    <v-stepper-header elevation="0" style="box-shadow: none;">
      <v-stepper-step :complete="step > 1" step="1" color="success">
        Veículo    
      </v-stepper-step>

      <v-stepper-step :complete="step > 2" step="2" color="success">
        Pagamento <span v-if="order">R$ {{ order.type_solicitation.value}}</span>
        <small>Forma de pagamento</small>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="newOrderForm" lazy-validation>
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" :xs="12">
              <OrderVehicleSelectForInclusion v-model="vehicle" />              
            </v-col>
            <v-col :lg="4" :md="4" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Tipo" :value="vehicle.kind.name" disabled outlined dense />
            </v-col>
            <v-col :lg="4" :md="4" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Renavam" :value="vehicle.renavam" disabled outlined dense />
            </v-col>
            <v-col :lg="4" :md="4" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Número Chassi" :value="vehicle.chassi.number" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Ano Chassi" :value="vehicle.chassi.year" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Cor" :value="vehicle.color.name" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Potência" :value="vehicle.power" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Combustível" :value="vehicle.fuel.name" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Modelo" :value="vehicle.model.name" disabled outlined dense />
            </v-col>          
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Ano Fabricação Carroceria" v-model="vehicle.fabrication_body_year" outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Último ano licenciamento" :value="vehicle.last_registration_year" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Capacidade Sentado" :value="vehicle.seating_capacity" disabled outlined dense />
            </v-col>            
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <v-radio-group
                class="mt-0"
                v-model="vehicle.air_conditioning"
                label="Possui ar?"
              >
                <v-radio label="Sim" :value="'true'"></v-radio>
                <v-radio label="Não" :value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <v-radio-group
                class="mt-0"
                v-model="vehicle.has_toilet"
                label="Possui sanitário?"
              >
                <v-radio label="Sim" :value="'true'"></v-radio>
                <v-radio label="Não" :value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <v-radio-group
                class="mt-0"
                v-model="vehicle.has_wifi"
                label="Possui wi-fi?"
              >
                <v-radio label="Sim" :value="'true'"></v-radio>
                <v-radio label="Não" :value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <v-radio-group
                class="mt-0"
                v-model="vehicle.has_accessibility"
                label="Possui acessibilidade?"
              >
                <v-radio label="Sim" :value="'true'"></v-radio>
                <v-radio label="Não" :value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Capacidade em Pé" v-model="vehicle.standing_capacity"  outlined dense />
            </v-col> 
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Ano fabricação" v-model="vehicle.fabrication_year"  outlined dense />
            </v-col>            
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">
              <v-text-field label="Estado" :value="vehicle.jurisdiction_uf.name" disabled outlined dense />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <VehicleOperationAreaSelect v-model="vehicle.area_of_operation" />
            </v-col>
            <v-col :lg="3" :md="3" :sm="12" :xs="12" v-if="vehicle">              
              <VehicleManufactoreBodySelect v-model="vehicle.body_manufacturer" />
            </v-col>
          </v-row>          
          <v-btn depressed color="success" @click="onSubmit" :disabled="!vehicle">
            Continuar
          </v-btn>    
        </v-form>        
      </v-stepper-content>

      <v-stepper-content step="2">        
        <OrderPaymentForm v-if="order" :order="order" />        
      </v-stepper-content>
    </v-stepper-items>   
  </v-stepper>
</template>

<script>
import OrderPaymentForm from './OrderPaymentForm.vue';
import OrderService from '@/services/order.service';
import OrderVehicleSelectForInclusion from './OrderVehicleSelectForInclusion.vue';
import VehicleOperationAreaSelect from './VehicleOperationAreaSelect.vue';
import VehicleManufactoreBodySelect from './VehicleManufactoreBodySelect.vue';

export default {
  name: "OrderCheckoutVehicleInclusion",
  
  components: {
    OrderPaymentForm,    
    OrderVehicleSelectForInclusion,
    VehicleOperationAreaSelect,
    VehicleManufactoreBodySelect
  },

  data: () => ({
    step: 1,

    order: null,

    vehicle: null,
  }),

  computed: {
    user: () => GlobalStore.user || {}
  },

  methods: {
    onSubmit() {
      if (!this.$refs.newOrderForm.validate()) return;      

      OrderService
        .createVehicleInclusion({vehicle: this.vehicle})
        .subscribe(({data}) => {
          this.fetchOrder(data.id);          
      });
    },

    onEventOrderCreated() {
      this.step = 2;
    },

    fetchOrder(order_id) {
      if (!order_id) return;

      OrderService
        .show(order_id)
        .subscribe({ 
          next: (data) => { 
            this.order = data;
            this.onEventOrderCreated();
          } 
        });
    },
  },
};
</script>